import { useEffect } from "react";

const SITE_NAME = "E-Com Benchmark Lab";
const DEFAULT_IMAGE = "https://images.unsplash.com/photo-1523206489230-c012c64b2b48?auto=format&fit=crop&w=1200&q=60";
// Fixed production domain so canonicals/OG stay correct in dev, preview and prerendering — never window.location.origin.
const SITE_URL = process.env.REACT_APP_SITE_URL;
if (!SITE_URL) throw new Error("REACT_APP_SITE_URL is required");

const setMeta = (attr, key, value) => {
  if (!value) return;
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", value);
};

const setCanonical = (href) => {
  let el = document.head.querySelector('link[rel="canonical"]');
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", "canonical");
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
};

const setRobots = (noindex) => {
  let el = document.head.querySelector('meta[name="robots"]');
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute("name", "robots");
    document.head.appendChild(el);
  }
  el.setAttribute("content", noindex ? "noindex, nofollow" : "index, follow");
};

/**
 * useSEO - sets document title, meta description, canonical URL, robots and
 * Open Graph / Twitter card tags for the current page.
 */
const useSEO = ({ title, description, path = "", image = DEFAULT_IMAGE, type = "website", noindex = false }) => {
  useEffect(() => {
    const fullTitle = title ? `${title} | ${SITE_NAME}` : `${SITE_NAME} — Compare. Test. Understand. Choose Better.`;
    const url = `${SITE_URL}${path}`;

    document.title = fullTitle;
    setMeta("name", "description", description);
    setCanonical(url);
    setRobots(noindex);

    setMeta("property", "og:title", fullTitle);
    setMeta("property", "og:description", description);
    setMeta("property", "og:url", url);
    setMeta("property", "og:type", type);
    setMeta("property", "og:image", image);
    setMeta("property", "og:site_name", SITE_NAME);

    setMeta("name", "twitter:card", "summary_large_image");
    setMeta("name", "twitter:title", fullTitle);
    setMeta("name", "twitter:description", description);
    setMeta("name", "twitter:image", image);
  }, [title, description, path, image, type, noindex]);
};

export default useSEO;
